(() => {
  const header = document.querySelector('.site-header');
  const menu = document.querySelector('[data-menu]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const search = document.querySelector('.header-search-wrap');
  const searchToggle = document.querySelector('[data-ui-search]');
  if (!header || !menu || !toggle || !search || !searchToggle) return;

  const backdrop = document.createElement('button');
  backdrop.type = 'button';
  backdrop.className = 'ui-search-backdrop';
  backdrop.tabIndex = -1;
  backdrop.hidden = true;
  backdrop.setAttribute('aria-label', searchToggle.dataset.closeLabel);
  document.body.append(backdrop);

  const searchInput = search.querySelector('input[type=search]');
  const clearSearch = search.querySelector('[data-ui-search-clear]');
  function syncClearSearch() {
    if (!searchInput || !clearSearch) return;
    clearSearch.hidden = searchInput.value.length === 0;
    clearSearch.style.display = clearSearch.hidden ? 'none' : '';
  }
  if (searchInput && clearSearch) {
    searchInput.addEventListener('input', syncClearSearch);
    clearSearch.addEventListener('click', event => {
      event.preventDefault();
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.focus({ preventScroll: true });
    });
    syncClearSearch();
  }

  const inertState = new Map();
  let frame = null;
  let locked = false;
  const searchOpen = () => search.classList.contains('ui-search-open');
  const menuOpen = () => menu.classList.contains('is-open');
  function syncLock() {
    const next = searchOpen() || menuOpen();
    document.documentElement.classList.toggle('ui-header-active', next);
    document.documentElement.classList.toggle('ui-search-active', searchOpen());
    backdrop.hidden = !next;
    backdrop.setAttribute('aria-label', searchOpen() ? searchToggle.dataset.closeLabel : toggle.getAttribute('aria-label'));
    if (locked === next) return;
    locked = next;
    if (locked) {
      document.querySelectorAll('main,footer').forEach(node => {
        inertState.set(node, node.inert);
        node.inert = true;
      });
    } else {
      inertState.forEach((value, node) => { node.inert = value; });
      inertState.clear();
    }
  }
  function setSpace(node, name, value) {
    const pixels = Math.max(0, Math.floor(value)) + 'px';
    if (node.style.getPropertyValue(name) !== pixels) node.style.setProperty(name, pixels);
  }
  function sync() {
    frame = null;
    const isSearching = searchOpen(), isMenu = menuOpen();
    // Keep the header's visual state fixed while a panel owns page scrolling.
    if (!isSearching && !isMenu) header.classList.toggle('ui-scrolled', scrollY > 80);
    header.classList.toggle('ui-menu-open', isSearching || isMenu);
    header.classList.toggle('ui-main-menu-open', isMenu);
    syncLock();
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
    const headerBottom = header.getBoundingClientRect().bottom;
    setSpace(search, '--ui-search-space', viewportBottom - headerBottom - 12);
    setSpace(menu, '--ui-menu-space', viewportBottom - headerBottom - 18);
  }
  function queueSync() { if (frame === null) frame = requestAnimationFrame(sync); }
  function closeMenu() {
    menu.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }
  function closeSearch() {
    search.dataset.uiSearchClosed = 'true';
    search.dispatchEvent(new Event('ui:search-close'));
    if (search.contains(document.activeElement)) document.activeElement.blur();
    search.classList.remove('ui-search-open');
    searchToggle.setAttribute('aria-expanded', 'false');
    searchToggle.setAttribute('aria-label', searchToggle.dataset.openLabel);
  }
  function closePanels(restoreFocus) {
    const target = searchOpen() ? searchToggle : toggle;
    closeSearch();
    closeMenu();
    sync();
    if (restoreFocus) target.focus({ preventScroll: true });
  }
  backdrop.addEventListener('click', () => closePanels(true));
  document.addEventListener('click', event => {
    if (event.target.closest('[data-menu-toggle]')) {
      // theme.js owns the menu toggle; read its completed state.
      closeSearch();
      sync();
      return;
    }
    if (event.target.closest('[data-ui-search-close]')) return closePanels(true);
    if (event.target.closest('[data-ui-search]')) {
      const opening = !searchOpen();
      closeMenu();
      if (opening) {
        search.dataset.uiSearchClosed = 'false';
        search.classList.add('ui-search-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        searchToggle.setAttribute('aria-label', searchToggle.dataset.closeLabel);
        sync();
        syncClearSearch();
        const input = search.querySelector('input[type=search]');
        input.focus({ preventScroll: true });
        if (input.value.trim().length >= 1) input.dispatchEvent(new Event('input', { bubbles: true }));
      } else closePanels(true);
      return;
    }
    if (!header.contains(event.target) || event.target.closest('a[href],.cart-link,[data-tracker-open]')) closePanels(false);
  });
  document.addEventListener('keydown', event => {
    if (!searchOpen() && !menuOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); closePanels(true); return; }
    if (event.key !== 'Tab') return;
    const panel = searchOpen() ? search : menu;
    const controls = [...panel.querySelectorAll('button:not([disabled]),input:not([type=hidden]):not([disabled]),a[href],summary')]
      .filter(node => node.getClientRects().length);
    if (menuOpen()) controls.unshift(toggle);
    const first = controls[0], last = controls.at(-1);
    if (!first) return;
    if (!controls.includes(document.activeElement)) {
      event.preventDefault(); (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });
  addEventListener('scroll', queueSync, { passive: true });
  addEventListener('resize', queueSync);
  addEventListener('pageshow', queueSync);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueSync, { passive: true });
    window.visualViewport.addEventListener('scroll', queueSync, { passive: true });
  }
  new MutationObserver(queueSync).observe(menu, { attributes: true, attributeFilter: ['class'] });
  new ResizeObserver(queueSync).observe(header);
  sync();
})();

(()=>{
  const initialize=root=>{
    if(root.dataset.uiCarouselReady)return;
    root.dataset.uiCarouselReady='true';
    const slides=[...root.querySelectorAll('[data-ui-slide]')],dots=[...root.querySelectorAll('[data-ui-dot]')],previous=root.querySelector('[data-ui-previous]'),next=root.querySelector('[data-ui-next]'),pause=root.querySelector('[data-ui-pause]'),position=root.querySelector('[data-ui-position]');
    if(slides.length<2||!previous||!next||!pause||!position)return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let current=0,paused=reduced.matches,hovered=false,focused=false,inView=true,timer=null,start=null;
    const clear=()=>{if(timer)clearTimeout(timer);timer=null;};
    const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.inert=!active;});dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===current)));position.textContent=`${current+1} / ${slides.length}`;};
    const schedule=()=>{clear();const running=!paused&&!hovered&&!focused&&inView&&!document.hidden;pause.setAttribute('aria-label',paused?root.dataset.playLabel:root.dataset.pauseLabel);pause.setAttribute('aria-pressed',String(paused));position.setAttribute('aria-live',running?'off':'polite');if(running)timer=setTimeout(()=>{show(current+1);schedule();},6000);};
    const manual=delta=>{paused=true;show(current+delta);schedule();};
    previous.addEventListener('click',()=>manual(-1));next.addEventListener('click',()=>manual(1));
    dots.forEach((dot,index)=>dot.addEventListener('click',()=>{paused=true;show(index);schedule();}));
    pause.addEventListener('click',()=>{paused=!paused;schedule();});
    root.addEventListener('mouseenter',()=>{hovered=true;schedule();});root.addEventListener('mouseleave',()=>{hovered=false;schedule();});
    root.addEventListener('focusin',()=>{focused=true;schedule();});root.addEventListener('focusout',()=>{requestAnimationFrame(()=>{focused=root.contains(document.activeElement);schedule();});});
    root.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();manual(event.key==='ArrowRight'?1:-1);}});
    root.addEventListener('pointerdown',event=>{if(event.button>0||event.target.closest('button'))return;start={x:event.clientX,y:event.clientY};});
    root.addEventListener('dragstart',event=>event.preventDefault());
    root.addEventListener('pointerup',event=>{if(!start)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;if(Math.abs(dx)>=50&&Math.abs(dx)>Math.abs(dy)*1.4){manual(dx<0?1:-1);root.dataset.uiSwipe='true';setTimeout(()=>delete root.dataset.uiSwipe,250);}});
    root.addEventListener('pointercancel',()=>{start=null;});root.addEventListener('click',event=>{if(root.dataset.uiSwipe&&event.target.closest('a')){event.preventDefault();event.stopPropagation();}},true);
    document.addEventListener('visibilitychange',schedule);
    reduced.addEventListener('change',()=>{if(reduced.matches)paused=true;schedule();});
    new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:.15}).observe(root);
    show(0);schedule();
  };
  document.querySelectorAll('[data-ui-carousel]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ui-carousel]').forEach(initialize));
})();

(()=>{
  const nav=document.querySelector('[data-ui-shop-scroll]'),previous=document.querySelector('[data-ui-shop-previous]'),next=document.querySelector('[data-ui-shop-next]');
  if (nav && previous && next && !nav.dataset.uiShopLoop) {
    const links = [...nav.children];
    const before = document.createDocumentFragment(), after = document.createDocumentFragment();
    const copy = (link, index) => {
      const clone = link.cloneNode(true);
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      clone.dataset.uiShopCopy = index;
      return clone;
    };
    for (let group = 0; group < 3; group++) {
      links.forEach((link, index) => before.append(copy(link, index)));
      links.forEach((link, index) => after.append(copy(link, index)));
    }
    nav.prepend(before); nav.append(after);
    nav.dataset.uiShopLoop = 'true';
    previous.disabled = false; next.disabled = false;
    let cycle = 0, origin = 0, scrollFrame = null, drag = null, blockClickUntil = 0, settleTimer = null, pointerActive = false;
    const instant = left => nav.scrollTo({ left, behavior: 'instant' });
    const measure = () => {
      if (!nav.clientWidth || !links.length) return;
      const phase = cycle ? ((nav.scrollLeft - origin) % cycle + cycle) % cycle / cycle : 0;
      const labelWidth = links.reduce((total, link) => total + link.getBoundingClientRect().width, 0);
      nav.style.gap = Math.max(2, Math.min(16, (nav.clientWidth - labelWidth - 8) / Math.max(1, links.length - 1))) + 'px';
      origin = links[0].getBoundingClientRect().left - nav.firstElementChild.getBoundingClientRect().left - 4;
      cycle = nav.children[links.length * 4].getBoundingClientRect().left - links[0].getBoundingClientRect().left;
      if (cycle > 0) instant(origin + phase * cycle);
    };
    const settle = () => {
      clearTimeout(settleTimer);
      if (!cycle || !nav.clientWidth || pointerActive) return;
      const target = origin + Math.round((nav.scrollLeft - origin) / cycle) * cycle;
      if (Math.abs(nav.scrollLeft - target) < .75) return;
      nav.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    const scheduleSettle = () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 180);
    };
    const wrap = () => {
      scrollFrame = null;
      if (!cycle || !nav.clientWidth) return;
      if (nav.scrollLeft < cycle || nav.scrollLeft > cycle * 5) {
        const phase = ((nav.scrollLeft - origin) % cycle + cycle) % cycle;
        instant(origin + phase);
      }
    };
    const move = direction => {
      if (!cycle) measure();
      wrap();
      nav.scrollBy({ left: direction * nav.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    nav.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
    });
    nav.addEventListener('scroll', () => {
      if (scrollFrame === null) scrollFrame = requestAnimationFrame(wrap);
      scheduleSettle();
    }, { passive: true });
    nav.addEventListener('pointerdown', event => {
      pointerActive = true;
      clearTimeout(settleTimer);
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, moved: false };
    });
    nav.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      if (!drag.moved) {
        const dx = Math.abs(event.clientX - drag.x), dy = Math.abs(event.clientY - drag.y);
        if (dx < 6 || dx <= dy) return;
        drag.moved = true; nav.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      instant(nav.scrollLeft + drag.lastX - event.clientX);
      drag.lastX = event.clientX;
    });
    const finishDrag = event => {
      pointerActive = false;
      scheduleSettle();
      if (!drag || event.pointerId !== drag.id) return;
      if (drag.moved) blockClickUntil = performance.now() + 250;
      if (nav.hasPointerCapture(event.pointerId)) nav.releasePointerCapture(event.pointerId);
      drag = null;
    };
    nav.addEventListener('pointerup', finishDrag);
    nav.addEventListener('pointercancel', finishDrag);
    nav.addEventListener('pointerleave', event => {
      if (!drag?.moved) finishDrag(event);
    });
    nav.addEventListener('dragstart', event => event.preventDefault());
    nav.addEventListener('click', event => {
      if (performance.now() < blockClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    nav.addEventListener('focusin', event => {
      const clone = event.target.closest('[data-ui-shop-copy]');
      if (clone) links[Number(clone.dataset.uiShopCopy)].focus({ preventScroll: true });
    });
    new ResizeObserver(measure).observe(nav);
    if (document.fonts) document.fonts.ready.then(measure);
    measure();
  }
  const banner=document.querySelector('[data-ui-announcements]'),pause=document.querySelector('[data-ui-banner-pause]');
  if(banner&&pause){let paused=matchMedia('(prefers-reduced-motion: reduce)').matches;const sync=()=>{banner.classList.toggle('ui-banner-paused',paused);pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);pause.querySelector('span').textContent=paused?'▷':'Ⅱ';};pause.addEventListener('click',()=>{paused=!paused;sync();});document.addEventListener('visibilitychange',()=>banner.classList.toggle('ui-banner-hidden',document.hidden));sync();}
})();

// Apply the same catalog-independent selection policy to product forms and setup cards.
// Short groups are easy to compare as buttons; dense or verbose lists stay native dropdowns.
function uiVariantButtonsFit(groups){
  return groups.length>0&&groups.reduce((count,values)=>count+values.length,0)<=20&&groups.every(values=>
    values.length<=10&&(values.length<=6||values.every(value=>value.length<=48))
  );
}

(()=>{
  function initialize(root){
    root.querySelectorAll('[data-ui-variant-picker]').forEach(picker=>{
      if(picker.dataset.ready)return;
      const form=picker.closest('form'),select=form.querySelector('[data-ui-variant-select]');
      const product=form.closest('.product-info'),price=product.querySelector('.product-price'),availability=product.querySelector('.availability');
      const add=form.querySelector('button[type="submit"]');
      const groups=[...picker.querySelectorAll('[data-ui-option-position]')];
      const variants=[...select.options].map(option=>({option,id:option.value,values:JSON.parse(option.dataset.options),available:option.dataset.available==='true'&&form.dataset.uiSoldOut!=='true'}));
      const buttons=uiVariantButtonsFit(groups.map(group=>[...group.querySelectorAll('input[type="radio"]')].map(radio=>radio.value)));
      let input=select;
      if(buttons){input=document.createElement('input');input.type='hidden';input.name='id';input.value=select.value;form.append(input);select.removeAttribute('name');}
      let selected=variants.find(variant=>variant.id===select.value);
      function setChoices(variant){if(!variant)return;groups.forEach((group,index)=>{group.querySelectorAll('input[type="radio"]').forEach(radio=>{radio.checked=radio.value===variant.values[index];});});}
      function update(variant){
        selected=variant;input.value=selected?.id||'';select.value=input.value;
        if(price)price.textContent=selected?selected.option.dataset.price:'—';
        if(availability){
          availability.textContent=selected?(selected.available?picker.dataset.availableLabel:picker.dataset.unavailableLabel):picker.dataset.missingLabel;
          if(selected?.available){
            const dot=document.createElement('span');
            dot.className='availability-dot';
            dot.setAttribute('aria-hidden','true');
            availability.prepend(dot,document.createTextNode(' '));
          }
        }
        add.disabled=!selected?.available||form.dataset.cartSubmitting==='true';add.textContent=selected?.available?picker.dataset.addLabel:picker.dataset.goneLabel;
        if(buttons){
          const choices=groups.map(group=>group.querySelector('input:checked')?.value);
          groups.forEach((group,index)=>group.querySelectorAll('input[type="radio"]').forEach(radio=>{
            const available=variants.some(candidate=>candidate.available&&candidate.values.every((value,position)=>value===(position===index?radio.value:choices[position])));
            radio.closest('.ui-variant-choice').classList.toggle('is-unavailable',!available);radio.title=available?'':picker.dataset.unavailableLabel;
          }));
        }
        if(selected){const url=new URL(location.href);url.searchParams.set('variant',selected.id);history.replaceState(history.state,'',url);}
      }
      select.addEventListener('change',()=>{const variant=variants.find(candidate=>candidate.id===select.value);setChoices(variant);update(variant);});
      picker.addEventListener('change',event=>{
        if(!event.target.matches('input[type="radio"]'))return;
        const choices=groups.map(group=>group.querySelector('input:checked')?.value);
        const variant=variants.find(candidate=>candidate.values.every((value,index)=>value===choices[index]));
        if(variant){select.value=variant.id;select.dispatchEvent(new Event('change',{bubbles:true}));}else update(undefined);
      });
      new MutationObserver(()=>{const busy=form.dataset.cartSubmitting==='true';if(buttons)picker.querySelectorAll('input[type="radio"]').forEach(radio=>{radio.disabled=busy;});else select.disabled=busy;}).observe(form,{attributes:true,attributeFilter:['data-cart-submitting']});
      picker.dataset.ready='true';form.dataset.uiVariantMode=buttons?'buttons':'dropdown';
      form.querySelector('[data-ui-variant-fallback]').hidden=buttons;picker.hidden=!buttons;
      setChoices(selected);update(selected);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(document));else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

(()=>{
  function initialize(root){
    root.querySelectorAll('.setup-options select').forEach(select=>{
      if(select.dataset.uiVariantMode)return;
      const titles=[...select.options].map(option=>option.textContent.split(' — ')[0].trim());
      select.dataset.uiVariantMode=uiVariantButtonsFit([titles])?'buttons':'dropdown';
      if(select.dataset.uiVariantMode==='dropdown')return;
      const label=select.parentElement.querySelector('label');
      const group=document.createElement('fieldset');group.className='ui-setup-variant-group';
      const legend=document.createElement('legend');legend.textContent=label.textContent;group.append(legend);
      const values=document.createElement('div');values.className='ui-setup-variant-values';group.append(values);
      const choices=[...select.options].map(option=>{
        const button=document.createElement('button');button.type='button';button.textContent=option.textContent.split(' — ')[0];button.title=option.textContent;button.disabled=option.disabled;
        button.dataset.variantId=option.value;button.setAttribute('aria-pressed',String(select.value===option.value));
        button.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));});values.append(button);return button;
      });
      select.addEventListener('change',()=>choices.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.variantId===select.value))));
      select.dataset.uiButtonSelect='true';select.hidden=true;label.hidden=true;select.after(group);
    });
  }
  function ready(){document.querySelectorAll('.setup-preview').forEach(section=>{initialize(section);new MutationObserver(()=>initialize(section)).observe(section,{childList:true,subtree:true});});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();

(()=>{
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-ui-brand-scroll]'),target=document.getElementById('shop-by-brand');
    if(!link||!target||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    event.preventDefault();
    const url=new URL(link.href,location.href);if(url.pathname!==location.pathname)return location.assign(link.href);
    const header=document.querySelector('.storecore-header-section');
    const offset=(header?header.getBoundingClientRect().bottom:0)+16;
    window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-offset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    history.replaceState(history.state,'',location.pathname+location.search+'#shop-by-brand');
  });
})();

;(() => {
  const initialize = () => {
    const browser = document.getElementById('shop-by-brand');
    const destination = '/collections/vgr';
    if (browser) {
      const picker = browser.querySelector('select');
      if (picker && !Array.from(picker.options).some(option => option.value === 'VGR')) {
        const option = new Option('VGR', 'VGR');
        const next = Array.from(picker.options).find(option => option.value.localeCompare('VGR', undefined, {sensitivity:'base'}) > 0);
        picker.insertBefore(option, next || null);
      }
      const form = picker && picker.closest('form');
      if (form) form.addEventListener('submit', event => {
        if (picker.value !== 'VGR') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        location.assign(destination);
      }, true);
      const grid = browser.querySelector('.brand-grid');
      if (grid && !grid.querySelector('a[href="/collections/vgr"]')) {
        const existing = Array.from(grid.children).find(link => link.textContent.replace(link.querySelector('.brand-logo')?.textContent || '', '').trim() === 'VGR');
        if (existing) existing.href = destination;
        else {
        const link = document.createElement('a');
        link.className = 'brand-link';
        link.href = destination;
        link.innerHTML = '<span class="brand-logo" aria-hidden="true"><span class="brand-logo-fallback">V</span></span>VGR';
        const next = Array.from(grid.children).find(link => link.textContent.replace(link.querySelector('.brand-logo')?.textContent || '', '').trim().localeCompare('VGR', undefined, {sensitivity:'base'}) > 0);
        grid.insertBefore(link, next || null);
        }
      }
      const vgrLink = grid?.querySelector('a[href="/collections/vgr"]');
      const logo = vgrLink?.querySelector('.brand-logo');
      if (logo && !logo.hasAttribute('data-stored-brand-logo')) {
        const image = document.createElement('img');
        image.src = 'https://cdn.shopify.com/s/files/1/0866/8607/3116/files/vgr-official-logo.png?v=1791155138&width=160'; image.alt = ''; image.width = 400; image.height = 133;
        image.loading = 'lazy'; image.decoding = 'async';
        image.style.cssText = 'width:100%;height:100%;object-fit:contain;padding:5px;';
        logo.replaceChildren(image);
      }
      const count = browser.querySelector('.brand-heading p');
      if (count && grid) count.textContent = 'Choose from ' + grid.children.length + ' brands';
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();

// VGR machine sets use the same setup section as individual machines.
(() => {
  const records = [{"handle":"vgr-stepless-pro-3-in-1-clipper-trimmer-and-shaver-kit-black","id":"10995977027868"},{"handle":"vgr-stepless-pro-3-in-1-clipper-trimmer-and-shaver-kit-red","id":"10995977126172"},{"handle":"vgr-v-640s2-pro-clipper-and-trimmer-combo-black","id":"10995977191708"},{"handle":"vgr-v-640s2-pro-clipper-and-trimmer-combo-green","id":"10995977322780"},{"handle":"vgr-v-640s3-pro-clipper-trimmer-and-shaver-trio-black","id":"10995977421084"},{"handle":"vgr-v-640s3-pro-clipper-trimmer-and-shaver-trio-green","id":"10995977552156"},{"handle":"vgr-v-600-and-v-900-super-trim-clipper-and-trimmer-set","id":"10995977617692"}];
  const initialize = () => {
    if (document.querySelector('[data-setup-preview]')) return;
    const handle = location.pathname.split('/products/')[1]?.split('/')[0];
    const record = records.find(item => item.handle === handle);
    const main = document.querySelector('main');
    const asset = [...document.scripts].find(script => /\/ui-preview\.js(?:\?|$)/.test(script.src));
    if (!record || !main || !asset) return;
    const assetUrl = filename => { const url = new URL(asset.src); url.pathname = url.pathname.replace(/ui-preview\.js$/, filename); return url.toString(); };
    const section = document.createElement('section');
    section.className = 'section setup-preview'; section.hidden = true;
    Object.assign(section.dataset, {setupPreview:'', productHandle:handle, productId:record.id, root:'/', currency:'USD', mappingUrl:assetUrl('setup-mappings.json'), extrasUrl:assetUrl('setup-extras.json')});
    section.innerHTML = '<div class="page-width"><div class="section-head"><div><h2>Complete your setup</h2><p>Useful VGR options and care products for your station.</p></div></div><p data-setup-status role="status" aria-live="polite"></p><div class="product-grid setup-grid" data-setup-grid></div><p data-setup-parts-help>Need a replacement blade or foil? Ask us to confirm a part for this exact model.</p></div>';
    const strings = document.createElement('script'); strings.type='application/json'; strings.dataset.setupStrings=''; strings.textContent="{\"add\":\"Add to cart\",\"add_both\":\"Add both to cart\",\"add_error\":\"We could not confirm that this item was added. Check your cart before trying again.\",\"added\":\"Added %product% to your cart.\",\"added_parts_error\":\"Added %product% to your cart. Its replacement part could not load; view the product or contact us for help.\",\"adding\":\"Adding…\",\"all_brands\":\"All brands\",\"already_covered\":\"Your cart already covers these suggestions.\",\"brand\":\"Brand\",\"browse_blades\":\"Browse clipper blades\",\"brush_reason\":\"Remove loose hair from accessible blades and housing as directed in your tool manual. Keep the tool off; do not force the brush into a protected head.\",\"cart\":\"Cart (%count%)\",\"choose_model\":\"Choose your model\",\"companion_cost\":\"Companion: %price% each × %quantity%.\",\"companion_note\":\"Companion tools are sold separately. Choose one to add it with this product at the price shown. Quantity applies to both tools.\",\"contact\":\"Confirm my replacement part\",\"curated\":\"Same-brand pairing\",\"curated_reason\":\"A selected %brand% tool to complement this model.\",\"exact_phrase\":\"Search as an exact phrase\",\"extra_fragrance\":\"Finishing touch\",\"extra_fragrance_reason\":\"A cologne or aftershave to complete your station. Check the product page for scent and use.\",\"extra_pomade\":\"Styling favorite\",\"extra_pomade_reason\":\"A pomade to finish the style. Check the product page for hold, shine and application.\",\"extra_spray\":\"Blade care\",\"extra_spray_reason\":\"Keep blade care on hand. Follow the spray label and your tool’s care instructions.\",\"extras_heading\":\"More for your station\",\"extras_intro\":\"Pomade, clipper spray and finishing favorites from our catalog.\",\"eyebrow\":\"\",\"facial_reason\":\"A same-brand option for facial finishing alongside your specialist grooming tool.\",\"find_parts\":\"Already own a tool? Find its parts\",\"finder_eyebrow\":\"Keep your tools working\",\"finder_fallback\":\"Enable JavaScript to use the model finder, or browse blades and ask us to confirm compatibility.\",\"finder_heading\":\"Find parts for the tool you own\",\"finder_intro\":\"Choose your brand and exact model. We’ll show replacement blades or foils when we’ve verified a fit.\",\"finishing_reason\":\"Finish pre-shortened stubble after trimming. This is a complementary shaver for this tool family.\",\"heading\":\"Complete your setup\",\"hero_eyebrow\":\"Professional barber supplies\",\"hero_heading\":\"Better tools. A complete setup.\",\"hero_local\":\"Shipped from Passaic, NJ\",\"hero_parts\":\"Find my replacement parts\",\"hero_shipping\":\"Free standard shipping on $100+ orders\",\"hero_shop\":\"Shop clippers\",\"hero_since\":\"Family-owned since 2012\",\"hero_text\":\"Shop professional clippers, trimmers and the replacement parts that keep them working.\",\"in_cart\":\"Tool is in your cart\",\"intro\":\"Compatible parts and useful tools selected for this model.\",\"load_error\":\"Some suggestions could not load. You can browse the product or contact us for help.\",\"loading\":\"Finding the right products…\",\"lower_price\":\"A lower-priced pairing\",\"maintenance\":\"Everyday maintenance\",\"maintenance_reason\":\"Keep your clipper and trimmer blades lubricated as directed in your tool manual.\",\"matching\":\"Matching family\",\"matching_reason\":\"Part of the %family% family. A complementary tool for your setup.\",\"model\":\"Tool model\",\"next_suggestion\":\"Next suggestion\",\"no_companion\":\"No companion — this tool only\",\"no_parts\":\"We haven’t verified a replacement part for this exact model yet. Contact us before buying a blade.\",\"no_parts_inline\":\"Need a replacement blade or foil? Ask us to confirm a part for this exact model.\",\"option\":\"Choose an option\",\"order_total\":\"Order total: %total%\",\"owned\":\"I own this tool — show its parts\",\"owned_tool\":\"You own this tool\",\"pairing_choice\":\"Choose your companion tool\",\"pairing_optional\":\"Choose your companion tool (optional)\",\"phrase_help\":\"Too many broad matches? Search these words together.\",\"previous_suggestion\":\"Previous suggestion\",\"professional\":\"Professional pairing\",\"professional_reason\":\"A %brand% %type% selected for a complementary job in your setup. This pairing uses different brands.\",\"replacement\":\"Compatible replacement\",\"replacement_reason\":\"Replacement for %model%. Check the model number on your tool before ordering.\",\"result_count\":\"products found\",\"settings_button\":\"Shop button label\",\"settings_finder\":\"Find parts for your tool\",\"settings_heading\":\"Heading\",\"settings_hero\":\"Store introduction\",\"settings_product\":\"Featured tool\",\"settings_recommendations\":\"Complete your setup\",\"settings_text\":\"Description\",\"shaving_reason\":\"Use this trimmer to shorten hair before finishing with your shaver. Follow the shaver manual for the required stubble length.\",\"shipping_detail\":\"Orders under $100: $10 standard shipping. Estimated delivery: 3–5 business days after processing.\",\"shipping_heading\":\"Free standard shipping on orders of $100 or more\",\"shipping_international\":\"Standard shipping is $10 on orders under $100 and free on orders $100+.\",\"shipping_link\":\"View shipping details\",\"show_parts\":\"Find compatible parts\",\"similar_price\":\"Within 25% of this tool’s price\",\"step_up\":\"A higher-priced pairing\",\"suggestion_position\":\"%current% of %total%\",\"suggestions_label\":\"Product suggestions\",\"unavailable\":\"Currently unavailable\",\"view_tool\":\"View this tool\"}"; section.append(strings); main.append(section);
    const css=document.createElement('link'); css.rel='stylesheet'; css.href=assetUrl('setup-preview.css'); document.head.append(css);
    const script=document.createElement('script'); script.type='module'; script.src=assetUrl('setup-preview.js'); document.head.append(script);
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
})();
